import CheckIcon from './CheckIcon';
import ProductMiniature from '../../product/miniature/ProductMiniature';
import { useTranslation } from '../../../hooks/useTranslation';
import type { Product } from '../../../models/Product';
import './AddToCartFinished.less';

type AddToCartFinishedProps = {
    addingToCartStatus: string;
    addingProducts?: Product[];
};

const AddToCartFinished = ({
    addingToCartStatus,
    addingProducts = []
}: AddToCartFinishedProps) => {
    const { t } = useTranslation();
    return (
        <div className={`bri-AddToCartFinished`}>
            {addingToCartStatus === 'success' && addingProducts && (
                <>
                    <div className="bri-AddToCartFinished-images-container">
                        {addingProducts.map(product => (
                            <div
                                className="bri-AddToCartFinished-image-container"
                                key={product.productId}
                            >
                                <ProductMiniature
                                    size="x-large"
                                    aspectRatio="1"
                                    product={product}
                                />
                                <CheckIcon />
                            </div>
                        ))}
                    </div>
                    <div className="bri-AddToCartFinished-success-text">
                        <span className="bri-HeadlineFont">
                            {addingProducts.length === 1
                                ? t('ADDED_TO_CART_ONE')
                                : t('ADDED_TO_CART_MANY')}
                        </span>
                    </div>
                </>
            )}
            {addingToCartStatus === 'error' && (
                <div
                    className={`bri-AddToCartFinished-error-text bri-DisplayFont`}
                >
                    {t('ADD_TO_CART_ERROR')}
                </div>
            )}
        </div>
    );
};

export default AddToCartFinished;
